<template>
  <div>
    <v-layout
      align-center
      class="mt-4"
      justify-space-between>
      <v-flex grow>
        <v-layout align-center>
          <span class="red--text text--accent-3 title">
            New
          </span>
          <span class="ml-3 title">•</span>
          <span class="ml-3 subheading">open unacknowledged</span>
        </v-layout>
      </v-flex>
      <v-flex shrink>
        <v-btn
          :disabled="selected.length === 0"
          class="light-blue darken-3 ma-0"
          style="min-width: 15em"
          @click="dialog = true">
          Acknowledge
        </v-btn>
      </v-flex>
    </v-layout>
    <v-container>
      <v-data-table
        v-if="issues.length > 0"
        v-model="selected"
        :headers="headers"
        :items="issues"
        disable-initial-sort
        hide-actions>
        <template
          slot="items"
          slot-scope="props">
          <tr>
            <td>
              <v-checkbox
                :input-value="props.selected"
                hide-details
                @click="props.selected = !props.selected"/>
            </td>
            <td>
              <router-link
                :to="{ name: 'issue', params: { id: props.item.id } }"
                class="clickable">
                {{ props.item.id | formatIId }}
              </router-link>
            </td>
            <td>
              <router-link
                :to="{ name: 'site', params: { id: props.item.site } }"
                class="clickable">
                {{ props.item.site }}
              </router-link>
            </td>
            <td>
              {{ props.item.description }}
            </td>
            <td>
              <v-tooltip left>
                <span slot="activator">
                  {{ props.item.dateRaised | formatFn }}
                </span>
                <span>{{ props.item.dateRaised | formatLLL }}</span>
              </v-tooltip>
            </td>
          </tr>
        </template>
      </v-data-table>
      <v-layout
        v-else
        class="mb-4"
        justify-center>
        <span class="body-2">No such issue.</span>
      </v-layout>
    </v-container>
    <ack-dialog
      v-model="dialog"
      :ids="selected.map((iss) => iss.id)"
      @refresh="$emit('refresh')"/>
  </div>
</template>

<script>
import AckDialog from "./AckDialog.vue";

export default {
  name: "open-unack-table",
  components: { AckDialog },
  props: {
    issues: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      dialog: false,
      headers: [
        {
          sortable: false,
          text: "",
          value: "",
          width: "6%"
        },
        {
          text: "ID",
          value: "id",
          width: "10%"
        },
        {
          text: "Site",
          value: "site",
          width: "10%"
        },
        {
          text: "Description",
          value: "description"
        },
        {
          text: "Date raised",
          value: "dateRaised",
          width: "20%"
        }
      ],
      selected: []
    };
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Issues/OpenUnackTable.vue